module.exports = __webpack_public_path__ + "nz.8d9d5b80e898aac97536.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/nz.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/nz.svg
// module chunks = styles